import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Box, Typography, Stack } from "@mui/material";

const data = [
  { name: "Male", value: 60 },
  { name: "Female", value: 40 },
];

const COLORS = ["#0088FE", "#FF69B4"];

const AudienceByGender = () => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "10px",
        borderRadius: "10px",
      }}
      textAlign="center"
      width="100%"
      maxWidth={600}
      mx="auto"
    >
      <Typography variant="p" gutterBottom>
        Gender
      </Typography>

      {/* Responsive Container for making chart responsive */}
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="40%"
            outerRadius="80%"
            fill="#8884d8"
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      {/* Legend */}
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        mt={2}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box width={10} height={10} bgcolor={COLORS[0]} />
          <Typography variant="body2">Male - 60%</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box width={10} height={10} bgcolor={COLORS[1]} />
          <Typography variant="body2">Female - 40%</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AudienceByGender;
